// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","containerImage":"App_containerImage__OF7Tr","containerSummary":"App_containerSummary__MDief"};